// para obtener todos los FREE_CONSULTATIONes
export const GET_FREE_CONSULTATION_LIST_SUCCESS = 'GET_FREE_CONSULTATION_LIST_SUCCESS';
export const GET_FREE_CONSULTATION_LIST_FAIL = 'GET_FREE_CONSULTATION_LIST_FAIL';

// para obtener el FREE_CONSULTATIONe busqueda
export const GET_FREE_CONSULTATION_SEARCH_SUCCESS = 'GET_FREE_CONSULTATION_SEARCH_SUCCESS';
export const GET_FREE_CONSULTATION_SEARCH_FAIL = 'GET_FREE_CONSULTATION_SEARCH_FAIL';